import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useMediaQuery } from 'react-responsive';

import authAxios from "../../components/authAxios";

import Pagination from '@mui/material/Pagination';
import DashboardHeader from "../../components/DashboardHeader";
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
// import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import { VisibilityOutlined } from "@mui/icons-material";
import TaskIcon from '@mui/icons-material/Task';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import BorderColorSharpIcon from '@mui/icons-material/BorderColor';

import moment from 'moment';

import Pillchip from "../../components/Pillchip";

// import PropertyEdit from "./PropertyEdit";
import EllipsisMenu from "../../components/EllipsisMenu";
import CustomSearchBar from "../../components/CustomSearchBar";
import ApplicationReview from "./ApplicationReviewOld";
import MobileApplications from "../../layouts/MobileLayout/MobileApplications";


const Applications = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const [isNewModalOpen, setIsNewModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const navigate = useNavigate()
    const [searchText, setSearchText] = useState('');
    const [application, setApplication] = useState("")

    const { data: applications } = useQuery({
        queryKey: ['applications', page, searchText],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/loan-applications/?page=${page}&search=${searchText}`);
          setPageCount(response.data.page_count)
          return response.data.results
        },
        enabled: !isMobile,
    });

    // const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // const handleDrawerOpen = () => {
    //     setIsDrawerOpen(true)
    // };
  
    // const handleDrawerClose = () => {
    //     setIsDrawerOpen(false)
    // };

    //Pagination
     const handlePageChange = (event, value) => {
        setPage(value);
    };

    const menuItems = (application) => {
        const items = [
            {
                label: 'View',
                icon: <VisibilityOutlined />,
                onClick: () => {
                    navigate(`/dashboard/application/${application.id}`)
                }
            }
        ];

        // const status = (application?.status_name || '').toLowerCase();
        if (application.status === 'PENDING') {
            items.push({
                label: 'Decision',
                // icon: <VisibilityOutlined />,
                icon: <CheckBoxIcon />,
                onClick: () => {
                    navigate(`/dashboard/loan-decision/${application.id}`)
                }
            });
        }

        return items;
    };


    // Must stay below the hooks above: isMobile flips on resize/rotate,
    // and returning earlier would change this component's hook count.
    if (isMobile) return <MobileApplications />;

    return (
        <div className="dashboard-main">

            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                
                    <DashboardHeader dashboardTitle="Applications" dashboardPreTitle="Loans" />
                    <div className="dashboard-content-header-nav-icons">
                        <CustomSearchBar 
                            searchText={searchText}
                            setSearchText={setSearchText}
                        />
                    </div>
                </div>

                <table className="styled-table">
                    <thead>
                        <tr >
                            <th>#</th>
                            <th>Reference</th>
                            <th>Date</th>
                            <th>Customer</th>
                            <th>Loan Type</th>
                            <th>Amount</th>
                            <th>Term</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>

                    {applications && applications.map(application => (

                        <tbody key={application.id}>
                            <tr>
                                <td>{application.id}</td>
                                <td>{application.lc_reference}</td>
                                <td>{moment(application.date).format('DD-MM-YYYY')}</td>
                                <td>{application.customer_name}</td>
                                <td>{application.product_name}</td>
                                <td>{Number(application.amount).toLocaleString()}</td>
                                <td>{application.term+' '+application.term_unit_name}</td>
                                <td><Pillchip label={application.status_name} /></td>
                                <td className='styled-table-menu'>
                                <EllipsisMenu items={menuItems(application)} />
                            </td>
                            </tr>
                        </tbody>
                    ))}
                    

                </table>

                <ApplicationReview 
                    application={application}
                    isModalOpen={isEditModalOpen}
                    setIsModalOpen={setIsEditModalOpen}
                />

                <Pagination 
                    className="custom-mui-pagination"
                    count={pagecount} 
                    page={page} 
                    onChange={handlePageChange} 
                />

                <Fab 
                    className="fab" 
                    color="primary" 
                    aria-label="add" 
                    onClick={()=>{
                        navigate('/dashboard/application-new') 
                        }   
                    }
                >
                    <AddIcon />
                </Fab>
                

            </section>
        </div>

    )
}
export default Applications